import { render, staticRenderFns } from "./SettingPhone.vue?vue&type=template&id=31f25938&scoped=true"
import script from "./SettingPhone.vue?vue&type=script&lang=js"
export * from "./SettingPhone.vue?vue&type=script&lang=js"
import style0 from "./SettingPhone.vue?vue&type=style&index=0&id=31f25938&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f25938",
  null
  
)

export default component.exports